import { cn } from "cn";
import Avatar from "@/components/ui/avatar/avatar";
import type { AttachmentUploader } from "./attachment";

/**
 * The uploader's avatar in a shadowed white ring, laid over a file's picture
 * (design `Uploader`): a 20px avatar, a 2px ring, 24px in all.
 */
export function AttachmentUploaderAvatar({
  uploader,
  className,
}: {
  uploader: AttachmentUploader;
  className?: string;
}) {
  return (
    <span
      title={uploader.name}
      className={cn(
        /* sorted */
        "flex",
        "p-0.5",
        "bg-bg-light rounded-full shadow",
        className,
      )}
    >
      <Avatar
        src={uploader.avatarUrl ?? ""}
        name={uploader.name}
        size="sm"
        className="drop-shadow-xs"
      />
    </span>
  );
}
